const summary = {
  a: {
    h3: 'MIŁOŚNIKIEM INNOWACJI!',
    boldtext: 'Twoją osobowość cechuje wysoka odpowiedzialność za gospodarkę. Mocno wierzysz w innowacyjne rozwiązania, nowe technologie i wizje, jakie niosą ze sobą wchodzące na rynek startupy. Myślisz szybko i kreatywnie, co pozwala Ci podejmować odpowiednie decyzje. ',
    text: 'Niezwykle ważny jest dla Ciebie rozwój – nie tylko swój, ale też innych. Kibicujesz więc wszelkim inicjatywom, które mają na celu promowanie przedsiębiorczości. Potrafisz zadbać o finansowe bezpieczeństwo swoich bliskich. Oszczędności lokujesz rozsądnie, ale jednocześnie nie zapominasz o tym, jak ważne jest inwestowanie.',
    responsibility: 'odpowiedzialności gospodarczej',
    href: '/raportcsr2018/pl/odpowiedzialnosc-gospodarcza.html'
  },
  b: {
    h3: 'DOBRYM PRACOWNIKIEM!',
    boldtext: 'Twoją osobowość cechuje wysoka odpowiedzialność zawodowa! Zawsze dajesz z siebie wszystko, dbasz o efekty i higienę pracy. Współpracownicy cenią Cię za kompetencje i gotowość do działania, którą potrafisz zarazić nawet szefa! Jesteś osobą kreatywną i komunikatywną, a Twoje pomysły pozwalają na rozwój firmy.',
    text: 'W pracy równie ważne jak efekty, jest dla Ciebie dobra atmosfera. To właśnie dlatego chętnie pomagasz innym, a Twoi współpracownicy zawsze mogą liczyć na Twój uśmiech. Pamiętasz też o równowadze pomiędzy rozwojem zawodowym, a życiem prywatnym. Cenisz sobie dostęp do benefitów, które oferuje Twoja firma, gdyż dzięki nim znacznie łatwiej możesz czerpać z życia pełnymi garściami.',
    responsibility: 'odpowiedzialności w miejscu pracy',
    href: '/raportcsr2018/pl/odpowiedzialnosc-w-miejscu-pracy.html'
  },
  c: {
    h3: 'ZAAGAŻOWANYM SPOŁECZNIKIEM!',
    boldtext: 'Twoją osobowość cechuje poczucie wysokiej odpowiedzialności za społeczność, której jesteś częścią! Wiesz, jak duży wpływ na jakość życia ma otaczająca nas rzeczywistość. To właśnie dlatego w Twoim towarzystwie panuje twórcza i odkrywcza atmosfera. ',
    text: 'Uwielbiasz uczestniczyć w wydarzeniach kulturalnych, a sztuka jest motorem, który napędza Cię do działania. Jednocześnie jesteś wrażliwy i pomocny. Angażujesz się w inicjatywy społeczne, mające na celu rozwiązywanie ważnych lokalnych problemów i pozytywne zmiany w twoim otoczeniu. Chętnie poświęcasz innym swój czas w ramach wolontariatu. Na co dzień dbasz o to, aby podejmowane przez Ciebie decyzje miały pozytywny wpływ na życie otaczających Cię ludzi.',
    responsibility: 'odpowiedzialności społecznej',
    href: '/raportcsr2018/pl/odpowiedzialnosc-spoleczna.html'
  },
  d: {
    h3: 'PRZYJACIELEM PRZYRODY!',
    boldtext: 'Twoją osobowość cechuje wysoka odpowiedzialność za środowisko naturalne! Wiesz, jak ważne znaczenie dla planety mają Twoje codzienne wybory. Starasz się minimalizować ślad węglowy, który po sobie pozostawiasz.',
    text: 'Bycie uczciwym w stosunku do natury jest dla Ciebie ważniejsze niż własna wygoda. Nie marnotrawisz zasobów naturalnych, segregujesz odpady i pamiętasz o tym, aby do sklepu zawsze brać płócienną torbę wielokrotnego użytku. Kiedy o czymś decydujesz, masz na uwadze nie tylko dobro własnego gatunku. Chcesz, aby Twoje wybory nie miały negatywnego wpływu na życie zwierząt i nie degradowały ekosystemów. Starasz się być świadomym konsumentem, który swoją postawą inspiruje do działania innych.',
    responsibility: 'odpowiedzialności wobec środowiska naturalnego',
    href: '/raportcsr2018/pl/odpowiedzialnosc-wobec-srodowiska-naturalnego.html'
  },
};

export function regularTemplate(id, question) {
  let answers = '';
  let btns = '';
  for(let i = 0; i < question.answers.length; i++) {
    let answer = '<label>'+ question.answers[i].text +
      '<input type="radio" name="question'+id+'" value="'+ question.answers[i].type +'" data-photo-number="'+ question.answers[i].number +'">' +
      '<span class="checkmark"></span>' +
    '</label>';
    answers += answer;
  }
  btns = '<button class="home-question__btn home-scroll-btn next" data-question-id="'+id+'" data-target-id="'+(parseInt(id)+1)+'" data-template-id="'+ question.template +'" disabled>następne</button>';

  let questionNumber = (id > 6) ? 'Pytanie dodatkowe' : 'Pytanie '+id+'/6';

  return '<div class="home-question" data-target-id="'+id+'">' +
    '<div class="container">' +
      '<div class="row d-flex flex-column-reverse flex-md-row">' +
        '<div class="col-12 col-md-6">' +
          '<div class="home-question__wrapper">' +
            '<p class="home-question__number">'+questionNumber+'</p>' +
            '<h3 class="home-question__title">'+question.question+'</h3>' +
            '<p class="home-question__subtitle">Wybierz odpowiedź, która najbardziej do Ciebie pasuje.</p>' +
            '<form class="home-question__form" data-question-id="'+id+'" data-id="'+ question.id +'" data-set-id="'+ question.set +'" data-template-id="'+ question.template +'">' + answers + '</form>' +
            '<div class="home-question__btns">' + btns + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="col-12 col-md-6">' +
          '<div class="text-center">' +
            '<img src="/raportcsr2018/assets/img/pytania/pytanie.png" alt="" class="home-question__img img-fluid" data-question-id="'+id+'">' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>';
} 

export function rangeTemplate(id, question) {
  let btns = '';
  let btn;
  for(let i = 0; i < question.answers.length+1; i++) {
    if(i < 2) {
      btn = '<button type="button" class="range__btn" data-range-step="'+ (i*25)+'" data-type="'+ question.answers[i].type +'" data-question-id="'+id+'">'+ question.answers[i].text +'</button>';
    } else if(i == 2) {
      btn = '<button type="button" class="range__btn range__btn--hide" disabled></button>';
    } else {
      btn = '<button type="button" class="range__btn" data-range-step="'+ (i*25)+'" data-type="'+ question.answers[i-1].type +'" data-question-id="'+id+'">'+ question.answers[i-1].text +'</button>'; 
    }
    btns += btn;
  }

  return '<div class="home-question" data-target-id="'+id+'">' +
    '<div class="container">' +
      '<div class="row">' +
        '<div class="col-12">' +
          '<div class="home-question__wrapper">' +
            '<p class="home-question__number">Pytanie '+id+'/6</p>' +
            '<h3 class="home-question__title">'+ question.question +'</h3>' +
            '<p class="home-question__subtitle">Zaznacz w jakim stopniu identyfikujesz się z powyższym stwierdzeniem.</p>' +
            '<form class="home-question__range" data-question-id="'+id+'" data-id="'+ question.id +'">' +
              '<img src="/raportcsr2018/assets/img/pytania/pytanie-'+id+'-'+question.set+'-'+question.template+'.png" alt="" class="range__topImg img-fluid">' +
              '<div>' +
                '<input type="range" class="range__input" id="" min="0" max="100" value="50" step="25" data-question-id="'+id+'">' +
                '<div class="range__btns">'+ btns +'</div>' +
              '</div>' +
            '</form>' +
            '<div class="home-question__btns">' +
              '<button class="home-question__btn home-scroll-btn" data-question-id="'+id+'" data-target-id="'+(parseInt(id)+1)+'" data-template-id="'+ question.template +'" disabled>następne</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>';
} 

export function circleTemplate(id, question) {
  let btns = '';
  let btn;
  for(let i = 0; i < question.answers.length; i++) {
    btn = '<button class="circle-slider__btn step'+(i+1)+'" data-circle-id="'+id+'" data-circle-step="'+ (i*25) +'" data-circle-img="'+(parseInt(i)+1)+'" data-type="'+ question.answers[i].type +'">'+ question.answers[i].text +'</button>';
    btns += btn;
  }

  return '<div class="home-question" data-target-id="'+id+'">' +
    '<div class="container">' +
      '<div class="row d-flex flex-column flex-md-row">' +
        '<div class="col-12 col-md-6 col-xl-4">' +
          '<div class="home-question__content">' +
            '<p class="home-question__number">Pytanie '+id+'/6</p>' +
            '<h3 class="home-question__title">'+ question.question +'</h3>' +
            '<p class="home-question__subtitle">Przeciągnij zielone kółko w odpowiednie miejsce lub zaznacz odpowiedź, której chcesz udzielić.</p>' +
          '</div>' +
        '</div>' +
        '<div class="col-12 col-md-6 col-xl-8">' +
          '<div class="circle-slider" data-id="'+ question.id +'" data-question-id="'+id+'">' +
            btns +
            '<img src="/raportcsr2018/assets/img/pytania/pytanie-circle.png" alt="" class="circle-slider__img" data-question-id="'+id+'">' +
            '<div id="question'+id+'" data-question-id="'+id+'" data-question-type="'+question.id+'"></div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="row">' +
        '<div class="home-question__content">' +
          '<div class="home-question__btns">' +
            '<button class="home-question__btn home-scroll-btn" data-question-id="'+id+'" data-target-id="'+(parseInt(id)+1)+'" data-template-id="'+ question.template +'" disabled>następne</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>';
}

export function finshTemplate(type) {

  return '<div data-target-id="" class="summary summary--'+type[0]+'">' +
      '<div class="summary__img"><img src="/raportcsr2018/assets/img/podsumowanie-'+type[0]+'.png" alt="" class="img-fluid"></div>' +
      '<div class="container">' +
        '<div class="row">' +
          '<div class="col-12 col-md-6">' +
            '<div class="home-question__content">' +
              '<p class="summary__subtitle">GRATULACJE! OKAZUJE SIĘ, ŻE JESTEŚ</p>' +
              '<h3 class="summary__title">'+summary[type[0]].h3+'</h3>' +
              '<p class="summary__text summary__text--bold">'+summary[type[0]].boldtext+'</p>' +
              '<p class="summary__text">'+summary[type[0]].text+'</p>' +
              '<p class="summary__more">Dowiedz się, co robimy w ramach</p>'+
              '<h4 class="summary__responsibility">'+summary[type[0]].responsibility+'</h4>'+
              '<a href="'+summary[type[0]].href+'" class="summary__link">zobacz</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
}